import BlockContent from "../block-content";
import styled from "styled-components";
import tw from "twin.macro";
import Image from "gatsby-plugin-sanity-image";

const Intro = styled.div`
  p {
    ${tw`text-white text-sm md:text-lg mb-8 md:mb-16`}
  }
`;
const Cards = styled.ul`
  width: 100%;
  @media screen and (min-width: 640px) {
    -moz-column-count: 2;
    column-count: 2;
  }
  @media screen and (min-width: 768px) {
    -moz-column-count: 3;
    column-count: 3;
  }
  li {
    -webkit-column-break-inside: avoid;
    page-break-inside: avoid;
    break-inside: avoid;
    ${tw`mb-4`}
  }
`;
const Description = styled.div`
  p {
    ${tw`text-sm mb-6`}
    &:last-child {
      ${tw`mb-0`}
    }
  }
`;
const PopularCoursesBlock = ({ props }) => {
  const popularCoursesBlock = props;

  return (
    <section
      key={popularCoursesBlock._key}
      className="bg-blue-500 py-8 md:py-24"
    >
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex flex-wrap">
          <div className="md:w-10/12 mx-auto">
            <hr className="w-8 border-yellow-500 border-4 mb-2" />
            <h2 className="text-white font-bold tracking-tighter text-xl md:text-4xl mb-1 md:mb-3 leading-none">
              {popularCoursesBlock.title}
            </h2>
            <Intro>
              <BlockContent blocks={popularCoursesBlock._rawBody} />
            </Intro>
          </div>
        </div>
        <Cards>
          {popularCoursesBlock.courses.map((course) => (
            <li key={course._id}>
              <div className="bg-white border-t-4 border-yellow-500 shadow-lg">
                <div className="p-4">
                  <h3 className="font-bold tracking-tighter leading-tight text-lg mb-2 text-gray-900">
                    <span className="uppercase font-normal tracking-wide text-gray-600 text-xs block mb-1">
                      {course.number}
                    </span>{" "}
                    {course.title}
                  </h3>
                  <Description>
                    <BlockContent blocks={course._rawDescription} />
                  </Description>
                </div>
              </div>
              {course.image && course.image.asset && (
                <Image
                  {...course.image}
                  width={352}
                  className="align-top"
                  alt={course.image.alt || `${course.title}`}
                />
              )}
            </li>
          ))}
        </Cards>
      </div>
    </section>
  );
};

export default PopularCoursesBlock;
